import userService from "../../../services/user.service";

async function getDesignations() {
  try {
    const payload = {
      filter: {
        textSearch: "",
      },
      pageNumber: -1,
      pageSize: 0,
    };
    const response = await userService.getDesignations(payload);
    if (response.data && response.data.status) {
      console.log(response.data.result);
      return JSON.stringify(response.data.result);
    } else {
      return (
        JSON.stringify(response.data.message) || "Failed to fetch designations."
      );
    }
  } catch (error) {
    const errorMessage =
      (error.response && error.response.data && error.response.data.message) ||
      error.message ||
      "An unexpected error occurred.";
    console.error("Error fetching designations:", errorMessage);
    return JSON.stringify(errorMessage);
  }
}
async function addDesignationToDatabase({
  designationName,
  shortName,
  designationLevelId,
  designationDescription,
  isActive,
}) {
  try {
    const payload = {
      name: designationName,
      shortName,
      description: designationDescription,
      active: isActive,
      levelId: designationLevelId,
    };
    const response = await userService.addDesignation(payload);
    if (response.data && response.data.status) {
      console.log(response.data.result);
      return JSON.stringify(response.data.result);
    } else {
      return (
        JSON.stringify(response.data.message) ||
        "Failed to get designation levels."
      );
    }
  } catch (error) {
    const errorMessage =
      (error.response && error.response.data && error.response.data.message) ||
      error.message ||
      "An unexpected error occurred.";
    console.error("Error getting designation level:", errorMessage);
    return JSON.stringify(errorMessage);
  }
}
async function updateDesignationInDatabase({
  designationId,
  designationName,
  shortName,
  designationLevelId,
  designationDescription,
  isActive,
}) {
  try {
    const payload = {
      id: designationId,
      name: designationName,
      shortName,
      description: designationDescription,
      active: isActive,
      levelId: designationLevelId,
    };
    const response = await userService.updateDesignation(payload);
    if (response.data && response.data.status) {
      console.log(response.data.result);
      return JSON.stringify(response.data.result);
    } else {
      return (
        JSON.stringify(response.data.message) || "Failed to update designation."
      );
    }
  } catch (error) {
    const errorMessage =
      (error.response && error.response.data && error.response.data.message) ||
      error.message ||
      "An unexpected error occurred.";
    console.error("Error updating designation:", errorMessage);
    return JSON.stringify(errorMessage);
  }
}

export default {
  addDesignationToDatabase,
  getDesignations,
  updateDesignationInDatabase,
  designationTools: [
    {
      type: "function",
      function: {
        name: "getDesignations",
        description:
          "Fetch all designations from the database. You must give all designations in return. Dont skip any data until you are told to do so.",
        parameters: {
          type: "object",
          properties: {},
        },
      },
    },
    {
      type: "function",
      function: {
        name: "updateDesignationInDatabase",
        description: "Update an existing designation in the database",
        parameters: {
          type: "object",
          properties: {
            designationId: {
              type: "string",
              description: "The unique ID of the designation to be updated",
            },
            designationName: {
              type: "string",
              description: "Name of the designation",
            },
            shortName: {
              type: "string",
              description: "This will be the short name for the designation",
            },
            designationLevelId: {
              type: "string",
              description:
                "You can use the getDesignationLevels function to return all the designation levels so that the user will select the designation level to give you designationLevelId",
            },
            designationDescription: {
              type: "string",
              description: "Description of the designation",
            },
            isActive: {
              type: "boolean",
              description: "Whether the designation is active or not",
            },
          },
          required: [
            "designationId",
            "designationName",
            "shortName",
            "designationLevelId",
            "designationDescription",
          ],
        },
      },
    },
    {
      type: "function",
      function: {
        name: "addDesignationToDatabase",
        description: "Add a designation to the database",
        parameters: {
          type: "object",
          properties: {
            designationName: {
              type: "string",
              description: "Name of the designation",
            },
            shortName: {
              type: "string",
              description: "This will be the short name for designation",
            },
            designationLevelId: {
              type: "string",
              description:
                "You must use the getDesignationLevels tool to return all the designation levels so that user will select the designation level to give you designationLevelId",
            },
            designationDescription: {
              type: "string",
              description: "Description of the designation",
            },
            isActive: {
              type: "boolean",
              description: "Whether the designation is active or not",
            },
          },
          required: [
            "designationName",
            "shortName",
            "designationLevelId",
            "designationDescription",
          ],
        },
      },
    },
  ]
};
